// src/components/Forbidden.js
import React from 'react';
export default function Forbidden() {
  return (
    <div className="p-8 text-center">
      <h1 className="text-2xl font-semibold">403 — Not authorized</h1>
      <p className="mt-2 text-gray-600">You don’t have access to this page.</p>
    </div>
  );
}
